import React from 'react';

import type { SanitizerOptions } from '~/components/hooks/useSanitizer';
import { useSanitizer } from '~/components/hooks/useSanitizer';
import EMAIL_BODY_ALLOWED_URL_PROTOCOLS from '~/server_shared/generated-types/EMAIL_BODY_ALLOWED_URL_PROTOCOLS';
import NOTE_HTML_ALLOWED_ATTRIBUTES from '~/server_shared/generated-types/NOTE_HTML_ALLOWED_ATTRIBUTES';
import NOTE_HTML_ALLOWED_IMAGE_TYPES from '~/server_shared/generated-types/NOTE_HTML_ALLOWED_IMAGE_TYPES';
import NOTE_HTML_ALLOWED_STYLES from '~/server_shared/generated-types/NOTE_HTML_ALLOWED_STYLES';
import NOTE_HTML_ALLOWED_TAGS from '~/server_shared/generated-types/NOTE_HTML_ALLOWED_TAGS';
import cn from '~/Utils/cn';

import './RichNoteText.css';

// The server sanitizes a rich note on every write it controls; sanitizing again here, with the same
// allow-list, keeps the render safe for a row written some other way (a bulk import, a data fix).
const NOTE_SANITIZER_OPTIONS: SanitizerOptions = {
  allowedTags: NOTE_HTML_ALLOWED_TAGS,
  allowedAttributes: NOTE_HTML_ALLOWED_ATTRIBUTES,
  allowedUriProtocols: EMAIL_BODY_ALLOWED_URL_PROTOCOLS,
  allowedStyles: NOTE_HTML_ALLOWED_STYLES,
  imageOnlyStyles: ['width', 'height'],
  allowedEmbeddedImageTypes: NOTE_HTML_ALLOWED_IMAGE_TYPES,
  openLinksInNewTab: true,
};

interface RichNoteTextProps {
  html: string;
  className?: string;
}

const RichNoteText: React.FC<RichNoteTextProps> = ({ html, className }) => {
  const { sanitize } = useSanitizer(NOTE_SANITIZER_OPTIONS);

  return (
    <div
      className={cn('rich-note text-sm text-slate-900', className)}
      data-testid="rich-note-text"
      dangerouslySetInnerHTML={{ __html: sanitize(html) }}
    />
  );
};

export default RichNoteText;
